module.exports = require("leaflet-iiif");